import { HTTP_ERROR_BAD_REQUEST, PASSWORD_INVALID } from '@ogsnetwork/opp-api-lib';
import { resetPassword } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
import { useStateWithValidation } from '../validation';
import { validatePassword } from './validation';
export function useResetPassword(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const dispatch = useAppDispatch();
    const previousAuthenticationStatus = usePrevious(authentication.status);
    const password = useStateWithValidation(validatePassword, '');
    const passwordConfirm = useStateWithValidation(useCallback((passwordConfirm) => {
        if (passwordConfirm !== password.value) {
            const errors = {
                passwordConfirm: [
                    {
                        type: PASSWORD_INVALID,
                        message: 'Passwords do not match'
                    }
                ]
            };
            return { isValid: false, errors };
        }
        return { isValid: true };
    }, [password.value]), '', [password.value]);
    const isValid = password.isValid && !password.isPristine && passwordConfirm.isValid && !passwordConfirm.isPristine;
    const dispatchResetPassword = useCallback(() => {
        if (isValid) {
            dispatch(resetPassword({
                token: props.token,
                password1: password.value,
                password2: passwordConfirm.value,
                userId: props.userId
            }));
        }
    }, [props, password.value, passwordConfirm.value, isValid]);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'success' && previousAuthenticationStatus === 'submitting') {
            (_a = props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        else if (authentication.status === 'error' && previousAuthenticationStatus === 'submitting') {
            (_b = props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    let validationErrors = undefined;
    if (!isValid) {
        validationErrors = {
            data: Object.assign(Object.assign({}, password.errors), passwordConfirm.errors),
            type: HTTP_ERROR_BAD_REQUEST
        };
    }
    return {
        errors: validationErrors !== null && validationErrors !== void 0 ? validationErrors : authentication.error,
        isValid,
        password: password.value,
        passwordConfirm: passwordConfirm.value,
        dispatchResetPassword,
        setPassword: password.setValue,
        setPasswordConfirm: passwordConfirm.setValue
    };
}
